export function forms() {
  $jq3(".interaction-form--immo .select2-box").select2({
    placeholder:
      window.ynTranslations && window.ynTranslations["bitte_waehlen"]
        ? window.ynTranslations["bitte_waehlen"]
        : "Bitte wählen...",
    allowClear: true,
    containerCssClass: "immo-dropdown",
    dropdownCssClass: "immo-dropdown",
    minimumResultsForSearch: 6,
    language: {
      errorLoading: function () {
        return "Die Ergebnisse konnten nicht geladen werden.";
      },
      noResults: function () {
        return "Keine Übereinstimmungen gefunden";
      },
      removeAllItems: function () {
        return "Entferne alle Gegenstände";
      },
    },
  });

  $jq3(".interaction-form--grey .select2-box").select2({
    placeholder:
      window.ynTranslations && window.ynTranslations["bitte_waehlen"]
        ? window.ynTranslations["bitte_waehlen"]
        : "Bitte wählen...",
    allowClear: true,
    containerCssClass: "immo-dropdown",
    dropdownCssClass: "immo-dropdown",
    minimumResultsForSearch: 6,
    language: {
      errorLoading: function () {
        return "Die Ergebnisse konnten nicht geladen werden.";
      },
      noResults: function () {
        return "Keine Übereinstimmungen gefunden";
      },
      removeAllItems: function () {
        return "Entferne alle Gegenstände";
      },
    },
  });

  $jq3(".interaction-form--default .select2-box").select2({
    placeholder:
      window.ynTranslations && window.ynTranslations["bitte_waehlen"]
        ? window.ynTranslations["bitte_waehlen"]
        : "Bitte wählen...",
    allowClear: true,
    containerCssClass: "default-dropdown",
    dropdownCssClass: "default-dropdown",
    minimumResultsForSearch: 6,
    language: {
      errorLoading: function () {
        return "Die Ergebnisse konnten nicht geladen werden.";
      },
      noResults: function () {
        return "Keine Übereinstimmungen gefunden";
      },
      removeAllItems: function () {
        return "Entferne alle Gegenstände";
      },
    },
  });

  $jq3(".select2-box").on("select2:open", function (e) {
    $jq3(".select2-results__options")
      .scrollbar()
      .parent()
      .addClass("scrollbar-inner");
  });

  $jq3(".button--open-contact-form").on("click", function (e) {
    if ($jq3(".panel--contact-form").length) {
      e.preventDefault();
      $jq3(".panel--contact-form").slideDown(400);

      const headerHeight = $jq3(".header").outerHeight();
      const topOffset =
        $jq3(".panel--contact-form").offset().top - headerHeight;

      $jq3("html, body").animate({ scrollTop: topOffset }, 500);
    }
  });

  $jq3(".property-contact-form__close-button").on("click", function (e) {
    e.preventDefault();

    $jq3(".panel--contact-form").slideUp(400);
  });

  $jq3(".widget--mui-text").focusin(function () {
    $jq3(this).find("label").addClass("focused");
    $jq3(this).find(".widget__input-container").addClass("focused");
  });

  $jq3(".widget--mui-text").focusout(function () {
    if ($jq3(this).find("input").val()) {
      $jq3(this).find("label").addClass("filled");
    } else {
      $jq3(this).find("label").removeClass("filled");
    }

    $jq3(this).find("label").removeClass("focused");
    $jq3(this).find(".widget__input-container").removeClass("focused");
  });

  $jq3(".widget--mui-textarea").focusin(function () {
    $jq3(this).addClass("focused");
  });

  $jq3(".widget--mui-textarea").focusout(function () {
    $jq3(this).removeClass("focused");
  });

  $jq3(".js-range-slider").each(function () {
    var fromTargetId = $jq3(this).data("from-id");
    var toTargetId = $jq3(this).data("to-id");
    var customValues = $jq3(this).data("custom-values");
    var minValueIndex = 0;
    var maxValueIndex = customValues.length - 1;

    $jq3(this).ionRangeSlider({
      from: minValueIndex,
      to: maxValueIndex,
      values: customValues,
      onChange: function (data) {
        $jq3("#" + fromTargetId).val(data.from_value);
        $jq3("#" + toTargetId).val(data.to_value);
      },
    });
  });

  $jq3(".property-form-slider--go-next").on("click", function (e) {
    e.preventDefault();

    const parentSlide = $jq3(this).closest(".property-form-slider__slide");
    const currentSlideId = parentSlide.data("form-step");

    $jq3(".property-form-slider__slide").each(function () {
      if ($jq3(this).data("form-step") === currentSlideId + 1) {
        $jq3(this).addClass("active");
      } else {
        $jq3(this).removeClass("active");
      }
    });

    $jq3(".blue-property-form__step-indicator").each(function () {
      if ($jq3(this).data("form-step") === currentSlideId + 1) {
        $jq3(this).addClass("active");
      } else {
        $jq3(this).removeClass("active");
      }
    });
  });

  $jq3(".property-form-slider--go-back").on("click", function (e) {
    e.preventDefault();

    const parentSlide = $jq3(this).closest(".property-form-slider__slide");
    const currentSlideId = parentSlide.data("form-step");

    $jq3(".property-form-slider__slide").each(function () {
      if ($jq3(this).data("form-step") === currentSlideId - 1) {
        $jq3(this).addClass("active");
      } else {
        $jq3(this).removeClass("active");
      }
    });

    $jq3(".blue-property-form__step-indicator").each(function () {
      if ($jq3(this).data("form-step") === currentSlideId - 1) {
        $jq3(this).addClass("active");
      } else {
        $jq3(this).removeClass("active");
      }
    });
  });
  calculateCheckboxWidth();

  $jq3(".property-form-slider__slide").each(function () {
    if ($jq3(this).data("form-step") === 0) {
      $jq3(this).addClass("active");
    } else {
      $jq3(this).removeClass("active");
    }
  });

  function calculateCheckboxWidth() {
    $jq3(".contains-managed-checkboxes").each(function () {
      const checkboxes = $jq3(this).find(".widget--checkbox");
      let widthestWidth = 0;
      checkboxes.each(function () {
        const thisWidth = $jq3(this).width();
        if (thisWidth > widthestWidth) widthestWidth = thisWidth;
      });

      checkboxes.each(function () {
        $jq3(this).css("width", widthestWidth + "px");
      });
    });
  }

  /*
    $jq3('.property-form-slider').on('init', function(event, slick, direction){
        let maxHeight = -1;
        $jq3('.property-form-slider .slick-slide').each(function() {
            if ($jq3(this).height() > maxHeight) {
                maxHeight = $jq3(this).height();
            }
        });
        $jq3('.property-form-slider .slick-slide').each(function() {
            $jq3(this).css('height', maxHeight+ 'px');
        });
    });

    $jq3(".property-form-slider").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        swipe: false,
        arrows: false,
        adaptiveHeight: false
    })

    $jq3('.property-form-slider').on('afterChange', function(event, slick, direction){
        $jq3('.blue-property-form__step-indicator').removeClass('active');
        $jq3('.blue-property-form__step-indicator[data-form-step="' + slick.currentSlide + '"]').addClass('active');
    });

    $jq3(".property-form-slider--go-next").on("click", function(e) {
        e.preventDefault();

        $jq3(".property-form-slider").slick("slickNext");
    })

    $jq3(".property-form-slider--go-back").on("click", function(e) {
        e.preventDefault();

        $jq3(".property-form-slider").slick("slickPrev");
    })
    */
}
